import React from 'react';

const ProductCard = ({ product, onAddToCart, inCart }) => {
  const totalStock = product.sizes?.reduce((sum, s) => sum + s.stock, 0) || 0;
  const outOfStock = totalStock === 0;

  return (
    <div
      key={product._id}
      className="relative bg-white rounded shadow p-2 hover:shadow-md transition cursor-pointer h-full flex flex-col justify-between"
      onClick={() => window.location.href = `/product/${product.productId}`}
    >
      {product.photos?.[0] && (
        <img
          src={`/uploads/${product.photos[0].replace(/\\/g, '/')}`}
          alt={product.name}
          className="w-full h-40 sm:h-60 object-cover rounded"
        />
      )}

      {outOfStock && (
        <div className="absolute top-2 right-2 bg-red-600 text-white text-xs px-2 py-1 rounded-full shadow">
          Out of Stock
        </div>
      )}

      <div className="p-2 md:space-y-1 text-xs md:text-sm">
        <h3 className="font-semibold truncate">{product.name}</h3>
        <p className="text-gray-600">Weight: {product.weight}g</p>
        <p className="text-gray-500 capitalize">{product.productType?.join(', ')}</p>
        <p className="text-blue-700 font-semibold">${product.price.toFixed(2)}</p>
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (inCart) {
              window.location.href = '/cart';
            } else {
              onAddToCart(product);
            }
          }}
          disabled={outOfStock}
          className={`mt-2 w-full text-sm py-1 rounded transition-all duration-300 ${
            outOfStock
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : inCart
              ? 'bg-green-600 hover:bg-green-700 text-white'
              : 'bg-blue-600 hover:bg-blue-700 text-white scale-105'
          }`}
        >
          {outOfStock ? 'Out of Stock' : inCart ? 'Go to Cart' : 'Add to Cart'}
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
